import { FC } from "react";

import { Column, Box, HtImage } from "@hightouch/htui";

export type Customer = {
  name: string;
  logo: string;
};

const customers: Customer[] = [
  {
    name: "Spotify",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/c79ef630644336a446eff2ccdc7afded6cd54c02-240x72.svg",
  },
  {
    name: "Aritzia",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/ffef00131ab19307fec4fa82af64da21a9eaf77b-2138x422.svg",
  },
  {
    name: "Domino's",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/8f11d589caa305eb61f3fe2511fa75ca40acf82e-667x148.png",
  },
  {
    name: "Nandos",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/7e562bef22a4df2fa16bbf96cc831fbd7c63492e-218x72.svg",
  },
  {
    name: "Warner Music Group",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/84dbb616e064de970801b02e16e419d60fcd4b44-2560x1009.png",
  },
  {
    name: "PetSmart",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/375df10710b9b2fbd2cf9c2ae5f669672753022d-607x150.png",
  },
  {
    name: "Whoop",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/5a41afd1824550ede6ff680a481ecfb022ef7a2f-205x35.svg",
  },
  {
    name: "Chime",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/c08b0fdac961455e9d6d6e222d80231fc43c7ef6-672x193.svg",
  },
  {
    name: "Iterable",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/390c5397fd12a45ff789cd04b79899cb387ea0c9-254x76.png",
  },
  {
    name: "Docusign",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/f838ba36868d8217b9dd0379fb06e131fbabdaa6-2500x504.png",
  },
  {
    name: "Headway",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/2100de02270f34575ca096f1d704cde80fda1e44-1836x360.png",
  },
  {
    name: "Viking Line",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/82c669194ee4475782397f700228abcdcf625539-200x24.png",
  },
  {
    name: "Ramp",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/acaf90882a1ded8a3796cc3972219355a42d009c-270x72.svg",
  },
  {
    name: "Grammarly",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/97b5edc507b55938a09d9cdb9f74afbd2cb21357-600x130.png",
  },
  {
    name: "Draft Kings",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/07623792febbbe7fa19c1af4f85de578c3252ef4-538x280.png",
  },
  {
    name: "Auto Trader",
    logo: "https://cdn.sanity.io/images/pwmfmi47/production/7101dff53d748438d7b85052a896483a362b5d97-1170x138.png",
  },
];

type Props = {
  logos?: { name: string; logo: string }[];
};

export const SplashLogos: FC<Readonly<Props>> = ({ logos = customers }) => {
  return (
    <Box
      display="grid"
      gridTemplateColumns={{ base: "repeat(4, 1fr)", lg: "repeat(8, 1fr)" }}
      alignItems="center"
      gridAutoRows={{ base: "28px", lg: "40px" }}
      gridGap={{ base: 10, lg: 6, xl: 10 }}
      width="100%"
    >
      {logos.map((customer) => (
        <Column
          key={customer.name}
          align="center"
          justify="center"
          flex={1}
          pos="relative"
        >
          <HtImage
            src={`${customer.logo}?w=300`}
            alt={`${customer.name}.`}
            width="100%"
            height="auto"
            maxHeight={{ base: "28px", lg: "40px" }}
            maxWidth={{ base: "110px", lg: "160px" }}
            objectFit="contain"
          />
        </Column>
      ))}
    </Box>
  );
};
